import { IconModel } from '../models/icon/icon.model';
import { IconStylingModel } from '../models/icon/icon-styling.model';
import { ButtonModel } from '../models/button/button.model';
import { ButtonStylingModel } from '../models/button/button-styling.model';
import { IconTemplates } from './icon.template';

export const /** @type {?} */ ButtonTemplates = {
  defaultTemplate: {
    property: new ButtonModel({
      display: true,
      disable: false,
      type: 'button',
      label: 'CF BUTTON',
      buttonTheme: 'mat-primary mat-raised-button'
    }),
    style : new ButtonStylingModel({
      container: {
        class: 'default-container'
      },
      button: {
        themeColor: 'primary'
      }
    })
  },

  submitTemplate: {
    property: new ButtonModel({
      display: true,
      disable: false,
      label: 'SUBMIT',
      iconProperty: null,
      iconPosition: 'left',
      buttonTheme: 'mat-primary mat-raised-button'
    }),
    style : new ButtonStylingModel({
      container: {
        class: '',
        dynamicClass: ''
      },
      button: {
        class: 'cf-submit-button',
        dynamicClass: '',
        themeColor: ''
      },
      iconStyling: new IconStylingModel ({
        icon: {
          class: '',
          dynamicClass: ''
        }
      })
    })
  }
}
